import { CSSProperties, useEffect } from 'react'
// import { useTranslation } from 'react-i18next'
import Scrollbars from 'react-custom-scrollbars-2'

import PlainLabel from 'app/common/ui-next/plain-label'
import { BankCardId, RecurrentBankCard } from 'app/dataTypes/acquiring/recurrent/cards'
import { useSelectFirstRadio } from 'app/common/ui-next/plain-radio-button'
import PlainFieldset from 'app/common/ui-next/plain-fieldset'

// import { CardNew } from './CardNew'
import { CardBank } from './CardBank'
import { SaveCardControls } from './controls'
import styles from './SavedCards.module.scss';

export interface CardsCustomCSS extends CSSProperties {
  '--card-width': string
  '--card-height': string
}

const cardWidth = '168px'
const cardHeight = '106px'
const cssVariables: CardsCustomCSS = {
  '--card-width': cardWidth,
  '--card-height': cardHeight,
}
/**
const testCard: Array<RecurrentBankCard> = [
  {
    id: '1',
    lastFourDigits: '2345',
    countryCode: 'ru',
    issuer: CardIssuer.TBank,
    system: CardSystem.Visa,
  },
  {
    id: '2',
    lastFourDigits: '9046',
    countryCode: 'ru',
    issuer: CardIssuer.TBank,
    system: CardSystem.Mastercard,
  },
  {
    id: '3',
    lastFourDigits: '5673',
    countryCode: 'ru',
    issuer: CardIssuer.Sber,
    system: CardSystem.Jcb,
  },
  {
    id: '4',
    lastFourDigits: '1223',
    countryCode: 'ru',
    issuer: CardIssuer.Sber,
    system: CardSystem.Mir,
  },
  {
    id: '5',
    lastFourDigits: '1234',
    countryCode: 'ru',
    issuer: CardIssuer.TBank,
    system: CardSystem.Unionpay,
  },
  {
    id: '6',
    lastFourDigits: '2434',
    countryCode: 'ru',
    issuer: CardIssuer.Unknown,
    system: CardSystem.Visa,
  },
  {
    id: '7',
    lastFourDigits: '5892',
    countryCode: 'ru',
    issuer: CardIssuer.Unknown,
    system: CardSystem.Visa,
  },
]
   */

type Props = {
  label: string
  selectedCardId: null | BankCardId
  savedBankCards: Array<RecurrentBankCard>
  onSavedCardRemove?: (id: BankCardId) => Promise<boolean>
  onChangeValue?: (id: BankCardId) => void
}

export const SavedCards = ({
  label,
  selectedCardId,
  savedBankCards,
  onSavedCardRemove,
  onChangeValue,
}: Props) => {
  // const { t } = useTranslation('finances')

  const radioRef = useSelectFirstRadio()

  // удаление checked, иначе моргает выбранный элемент
  useEffect(() => {
    const inputs = document.querySelectorAll<HTMLInputElement>(
      `input[name="${SaveCardControls.Card}"]`,
    )
    inputs.forEach((input) => {
      if (input.type === 'radio') {
        input.checked = false
      }
    })
  }, [])

  return (
    <>
      {label && (
        <PlainLabel htmlFor="cards" skipUpperSpace>
          {`${label}:`}
        </PlainLabel>
      )}
      <div className={styles.root} style={cssVariables}>
        <Scrollbars className={styles.scroll} autoHeight autoHeightMin={120}>
          <PlainFieldset
            id="cards"
            className={styles.cards}
            ariaLabelledby="cards"
            skipVerticalSpaces
          >
            {savedBankCards.map(({ id, lastFourDigits, issuer, system }) => (
              <CardBank
                key={id}
                ref={radioRef}
                id={id}
                checked={id === selectedCardId}
                groupName={SaveCardControls.Card}
                label={`${issuer} ${lastFourDigits}`}
                lastFourDigits={lastFourDigits}
                system={system}
                issuer={issuer}
                onTrashButtonClick={onSavedCardRemove}
                onChangeValue={onChangeValue}
              />
            ))}
            {/* <CardNew ref={radioRef} id="new" groupName="card">
              {t('new_card', 'Новая карта')}
            </CardNew> */}
          </PlainFieldset>
        </Scrollbars>
      </div>
      <div className={styles.stub} style={cssVariables} />
    </>
  )
}
